import "bootstrap-datepicker/dist/js/bootstrap-datepicker"
import $ from 'jquery';
import 'jquery-mask-plugin';

$(() => {
  const mask = 'FF:FF:FF:FF:FF:FF';
  const maskParams = {
    translation: {"F": {pattern: "[0-9a-fA-F]"}},
    onKeyPress: (str, e, obj) => $(obj).val(str.toUpperCase())
  };

  // enable CTRL+Return in textareas
  $('form textarea').keydown(e => {
    if (e.keyCode === 13 && e.ctrlKey) {
      $(this).closest('form').submit();
    }
  });


  /**
   * Navigate to the first link found in an element
   */
  function navigateToFirstLink(element) {
    const link = element.querySelector ? element.querySelector('a[href]') : $(element).find('a[href]')[0];
    if (link && link.href) {
      window.location.href = link.href; // navigate to the link
    }
  }

  // autolink table rows
  $(".link_rows_to_first tbody tr, .index-table tbody tr").css("cursor", "pointer").click(e => {
    const target = $(e.target);
    const row = $(e.currentTarget);
    const table = row.closest('table');

    // Don't trigger if clicking on a link directly or its child elements
    if (target.is('a') || target.closest('a').length > 0) {
      return;
    }

    // Skip if this table also has table_click_checkboxes class (handled separately)
    if (table.hasClass('table_click_checkboxes')) {
      return;
    }

    // Don't trigger if clicking inside a dropdown menu or on form elements
    if (target.closest('.dropdown-menu').length > 0 ||
        target.is('button, input, form') ||
        target.closest('button, form').length > 0) {
      return;
    }

    if (!(target.data('bs-toggle') === 'dropdown') && !target.hasClass('btn')) {
      navigateToFirstLink(e.currentTarget);
    }
  });


  // autosubmit forms
  $(".autosubmit").change(e => $(e.target).closest("form").submit());


  // mask ip addresses
  $('form .ip_mask').mask('099.099.099.099');


  // datepicker
  $('[data-behaviour~=datepicker]').datepicker({
    weekStart: 1,
    format: "yyyy-mm-dd",
    calendarWeeks: true,
    clearBtn: true,
    autoclose: true,
    todayHighlight: true
  });


  /**
   * Format MAC address input fields (only initially, not on added fields)
   */
  $('form input.macaddress').mask(mask, maskParams);


  /**
   * Click checkboxes in table rows and handle link navigation.
   */
  document.querySelectorAll('table.table_click_checkboxes tbody tr').forEach(row => {
    // Remove any previous click handler by cloning the node
    const newRow = row.cloneNode(true);
    row.parentNode.replaceChild(newRow, row);
    newRow.addEventListener('click', e => {
      // Ignore clicks on inputs, links, or buttons
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'A' || e.target.tagName === 'BUTTON' || e.target.closest('a,button,input')) return;

      const cb = newRow.querySelector('input[type=checkbox]');
      const table = newRow.closest('table');

      if (cb) {
        // If checkbox exists, toggle it
        cb.checked = !cb.checked;
      } else if (table.classList.contains('link_rows_to_first')) {
        // If no checkbox but has link_rows_to_first class, navigate to first link
        navigateToFirstLink(newRow);
      }
    });
  });

  // Double-click in .well triggers "Edit" button if present
  $('.well').dblclick(e => {
    const $well = $(e.currentTarget);
    const $editBtn = $well.find(".btn:contains('Edit')").first();
    if ($editBtn.is('a[href]')) {
      window.location.href = $editBtn.attr('href'); // navigate to the link
    } else {
      $editBtn.trigger('click'); // fallback to default
    }
  });

  // Auto-size textareas with class 'auto-size'
  function autoSizeTextarea($ta) {
    const el = $ta[0];
    // Only resize if content has overflowed
    if (el.scrollHeight > el.clientHeight) {
      $ta.css('height', el.scrollHeight + 'px');
    }
  }
  $('textarea.auto-size').each(function() {
    const $this = $(this);
    // Set initial min-height based on content
    $this.css('height', 'auto');
    $this.css('height', this.scrollHeight + 'px');
    $this.css('min-height', this.scrollHeight + 'px');
  }).on('input', function() {
    autoSizeTextarea($(this));
  });

});


window.copyToClipboard = function(text) {
  navigator.clipboard.writeText(text).then(
    () => {},
    err => console.warn('Could not copy text: ', err)
  );
}
